import Modal from "../../components/Modal";
import Button from "../../components/Button";

export default function SendEmailConfirmationModal({
                                                       open,
                                                       onClose,
                                                       onConfirm,
                                                   }: {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}) {
    return (
        <Modal heading="Send Email Confirmation" onClose={onClose}>
            <p className="mb-4">Are you sure you want to send the report to the respondent?</p>
            <div className="flex justify-end gap-3">
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} theme="primary">Yes, Send</Button>
            </div>
        </Modal>
    );
}
